var render, staticRenderFns
import script from "./listCommonContent.vue?vue&type=script&lang=js"
export * from "./listCommonContent.vue?vue&type=script&lang=js"
import style0 from "./listCommonContent.vue?vue&type=style&index=0&id=250c848e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250c848e",
  null
  
)

export default component.exports